/**
 * Diagnostic logger for navigation lifecycle events.
 *
 * Emits a structured warn entry tagged `[nav]` so downstream tooling
 * (cypress-terminal-report in CI, browser devtools locally) can correlate
 * pathname changes, router recreations, and forced redirects across a session.
 */

type NavLogEvent =
  | 'redirect-forbidden-fired'
  | 'router-recreated'
  | 'pathname-changed';

interface NavLogPayload {
  event: NavLogEvent;
  pathname: string;
  [key: string]: unknown;
}

export function navLog(payload: NavLogPayload): void {
  const entry = {
    timestamp: new Date().toISOString(),
    ...payload,
  };

  console.warn('[nav]', entry);
}
